import { useMemo } from 'react'

import { ModalVariant } from '@cash-web/shared-feature-modal'
import { BlockerType } from '@cash-web/shared-flow-data-access-context'
import { JourneyData, JourneyTarget } from '@cash-web/shared-journey-util-main'

import { JourneyStore, useJourneyStoreSyncOnBlockerChange } from './JourneyStoreProvider'

const targetOverride: Partial<Record<BlockerType, JourneyTarget>> = {
  card_customization: 'fullscreen',
}

export const getModalVariant = (journey: JourneyData): ModalVariant | undefined => {
  return journey.routeConfig?.modalVariant ?? (journey.opts?.['modalVariant'] as ModalVariant | undefined)
}
export const getTarget = (journey: JourneyData, blockerType?: BlockerType) => {
  const modalVariant = getModalVariant(journey)
  const blocker = !blockerType ? journey.initialBlocker : blockerType

  let target = modalVariant === 'fullscreen' ? 'fullscreen' : journey.routeConfig?.target ?? journey.opts?.scope?.target
  if (blocker && targetOverride[blocker]) {
    target = targetOverride[blocker]
  }

  return target
}

export const getTargetHistory = (history: JourneyData[], store?: JourneyStore) => {
  const targetHistory: Partial<Record<JourneyTarget, JourneyData[]>> = {}

  for (const journey of history) {
    const storeInstance = store?.getSnapshot(journey.journeyId)
    const blockerType = storeInstance?.flow?.active?.blockerData?.type
    const target = getTarget(journey, blockerType) ?? 'modal'
    targetHistory[target] ??= []
    targetHistory[target].push(journey)
  }

  return targetHistory
}

export const useTargetHistory = (history: JourneyData[]) => {
  const { store, syncValue } = useJourneyStoreSyncOnBlockerChange()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => getTargetHistory(history, store), [history, store, syncValue])
}
